import { CognitoUser } from "@aws-amplify/auth";
import { Auth } from "aws-amplify";
export const getJwtToken = async (): Promise<string> => {
  try {
    const defaultJwt = "FakeJwt";
    const cognitoUser: CognitoUser = await Auth.currentAuthenticatedUser();
    if (cognitoUser) {
      const session = cognitoUser.getSignInUserSession();
      return session?.getIdToken()?.getJwtToken();
    }

    return defaultJwt;
  } catch (error) {
    console.log(error);
  }
};
